function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M184.665 139.626c-5.979.309-11.968.774-17.957.898-37.887.772-71.915-10.348-102.084-33.256-13.167-10.005-24.366-21.847-33.847-35.354-.712-1.02-1.515-1.96-2.61-3.384-4.324 10.239-8.498 20.098-13.075 30.935C11.088 89.692 7.4 80.792 3.84 71.84c-.32-.788-.066-1.966.271-2.816 6.39-15.361 12.84-30.68 19.408-46.339 1.456.503 2.753.86 4.009 1.392 13.698 5.702 27.42 11.333 41.031 17.253 1.896.83 3.817 2.765 4.658 4.67 3.641 8.105 6.882 16.39 10.6 25.37-6.774-2.794-12.784-5.274-19.045-7.836 6.988 18.52 52.643 43.481 87.339 45.508 60.461 3.534 103.464-24.014 131.144-77.624 9.083 3.889 18.419 7.877 27.994 11.983-8.835 19.89-20.616 37.247-36.133 52.048-20.007 19.101-43.216 32.52-70.061 39.501-5.392 1.399-10.816 2.701-16.233 4.053-1.367.217-2.771.422-4.157.624z",
  fill: "#FFD747"
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 319 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrow;